<template>
  <div id="app">
      <router-view/>
  </div>
</template>
<script>
import {weixinShare} from './utils/wxShare'
export default {
  name: 'App',
  methods: {
    loadWx() {
      const path = this.$route.path;
      let descr = '';
      switch (path) {
        case '/mobile/summit-meeting-awards':
          descr = '由绿色金融60人论坛主办的“GF60绿色金融奖”于12月23日隆重揭晓';
          break;
        case '/mobile/summit-meeting':
          descr = '由昆明市人民政府、绿色金融60人论坛联合主办的“2022绿色金融国际峰会·滇池论坛”于12月23日盛大召开';
          break;
        case '/mobile/green-finance-award-2023':
          descr = '报名通道火热开启，点击“立即报名”按钮参与活动';
        break;
        case '/mobile/green-finance-award-2024':
          descr = '报名通道火热开启，点击“立即报名”按钮参与活动';
        break;
        case '/mobile/green-finance-award-2025':
          descr = '报名通道火热开启，点击“立即报名”按钮参与活动';
        break;
        default:
          descr = '绿色金融60人论坛(英文名“Green Finance Forum of 60”，简称 “GF60”)是非营利性的国际化绿色金融交流平台，以上海金司南金融研究院为依托，汇聚全球绿色产业领军机构与金融行业资深专家，致力于建设具有公信力与影响力的绿色金融交流平台，共同推动绿色金融创新，服务可持续经济长期健康发展。';
          break;
      }

      let image = '';
      switch (path) {
        case '/mobile/summit-meeting':
          image = 'https://gf60.org.cn/upload/owe/48e798a1506a484194f95911ecbee4d8.jpg';
          break;
        case '/mobile/summit-meeting-awards':
          image = 'https://gf60.org.cn/upload/owe/4930813170c6404f805da497ebf22a79.jpg';
          break;
        case '/mobile/green-finance-award-2023':
          image = 'https://gf60.org.cn/upload/owe/bb0b3c34c6684de1b166c271c2ff0426.jpg';
        break;
        case '/mobile/green-finance-award-2024':
          image = 'https://image.gf60.org.cn/upload/owe/a5634cb73d444d4aa234b1244fdaa732.jpg';
        break;
        case '/mobile/green-finance-award-2025':
          image = 'https://image.gf60.org.cn/upload/owe/66b18617cb654039b7f0d8362acb8265.jpg';
        break;
        default:
          image = 'https://image.gf60.org.cn/upload/owe/aeceac6fedf44bee867966e1257548e5.jpg';
          break;
      }

      let title = document.title;
      switch (path) {
        case '/mobile/summit-meeting':
          title = '2022绿色金融国际峰会·滇池论坛';
          break;
        case '/mobile/summit-meeting-awards':
          title = 'GF60绿色金融奖评选';
          break;
          case '/mobile/green-finance-award-2023':
          title = '2023年度“GF60绿色金融奖”';
          break;
          case '/mobile/green-finance-award-2024':
          title = '2024年度“GF60绿色金融案例”';
          break;
        case '/mobile/green-finance-award-2025':
          title = '2025 GF60可持续发展评选';
          break;
      }

      weixinShare({
        link: window.location.href,
        image,
        title,
        descr
      });
    }
  },
    watch: {
    '$route.path': {
      immediate: true,
      handler(v) {
        this.loadWx();
      }
    }
  },
  
}
</script>
<style lang="less">
body {
  margin: 0;
  color: #2e2e2e;
  font-family: 'Arial';

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

}
</style>
